module.exports = __webpack_public_path__ + "img/fog_light.997c49a0.svg";